"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var DEFAULT_COUNTRY = 'us';
var LANG_TO_ISO2 = {
  de: 'de',
  en: 'us',
  es: 'es',
  fi: 'fi',
  fr: 'fr',
  it: 'it',
  ja: 'jp',
  nl: 'nl',
  sv: 'se'
};

var _default = function _default(locale) {
  var _locale$split = locale.split('-'),
      _locale$split2 = (0, _slicedToArray2.default)(_locale$split, 2),
      lang = _locale$split2[0],
      country = _locale$split2[1];

  if (country) {
    return country;
  } else if (LANG_TO_ISO2[lang]) {
    return LANG_TO_ISO2[lang];
  }

  return DEFAULT_COUNTRY;
};

exports.default = _default;
module.exports = exports.default;